import React, { useEffect, Component } from 'react';
import '../src/styles/css/main.css';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';

class App extends Component {
  componentDidMount() {
    const googleScript = document.createElement('script');
    googleScript.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    googleScript.async = true;
    document.body.appendChild(googleScript);

    const fbScript = document.createElement('script');
    fbScript.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.3&appId=1472587806338388&autoLogAppEvents=1';
    fbScript.async = true;
    fbScript.defer = true;
    fbScript.crossOrigin = 'anonymous';
    document.body.appendChild(fbScript);

    const flexboxLink = document.createElement('link');
    flexboxLink.rel = 'stylesheet';
    flexboxLink.type = 'text/css';
    flexboxLink.href = 'https://unpkg.com/react-flexbox-grid@2.1.2/dist/react-flexbox-grid.css';
    document.head.appendChild(flexboxLink);
  }
  render() {
    return (
      <div className='App'>
        <div id='fb-root' />
      </div>
    );
  }
}

export default DragDropContext(HTML5Backend)(App);
